module.exports = __webpack_public_path__ + "img/FanClashLogo.1c942b0f.png";